import '.n{width:100%;}.ssr-plugin'
import '.ce{border-radius:0.75rem;}.ssr-plugin'
import '.i0{padding:0.5rem 1rem;}.ssr-plugin'
import '.cf{font-size:1.125rem;}.ssr-plugin'
import '.fi{line-height:1.75rem;}.ssr-plugin'
import '.i2{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef, FocusEventHandler } from 'react'
import { InputField } from '../InputField'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  label?: string
  labelStyle?: Style
  required?: boolean
  minHeight?: string
  style?: Style
  errorMessage?: string
  onBlur?: FocusEventHandler<HTMLTextAreaElement>
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      label,
      labelStyle,
      required,
      minHeight = '6.5rem',
      style,
      errorMessage,
      onBlur,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    const hasError = !!errorMessage
    return (
      <InputField
        label={label}
        labelStyle={labelStyle}
        required={required}
        errorMessage={errorMessage}
      >
        <styled.textarea className="n ce i0 cf fi i2"
          ref={ref}
          style={{
            minHeight: minHeight,
            border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--palette-blue-300)'}`,
            background: hasError
              ? 'var(--status-error-muted)'
              : 'var(--palette-white)',
            '&:focus': {
              outline: 'none',
              border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--brand-secondary)'}`,
            },
            ...style,
          }}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onChange={(e) => setValue(e.target.value)}
        ></styled.textarea>
      </InputField>
    )
  },
)
